import React from "react";
import { CommonHeadingWrapper } from "../../styles/StyledComponents/CommonHeadingWrapper";
import { ICommonHeadingProps } from "../../ui/interface";

const CommonHeading: React.FC<ICommonHeadingProps> = ({
  children,
  isPrimary,
  paratext,
  title,
  alignText,
  ...props
}) => {
  return (
    <CommonHeadingWrapper alignText={alignText} {...props}>
      <div className="upper_heading_wrap">
        {title && (
          <h2 className={isPrimary ? "heading_primary_color" : ""}>{title}</h2>
        )}
        {paratext && <p>{paratext}</p>}
      </div>
      {children}
    </CommonHeadingWrapper>
  );
};

export default CommonHeading;
